import * as actionTypes from './actionsTypes';

export function getHoldersList(params) {
	/**
	 * @param clientId
	 */
	return {
		type: actionTypes.HOLDERS_LIST_GET,
		payload: {
			params,
		},
	};
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/holders.js